import type { ReactNode } from "react";
import "./ScheduleValidationButton.scss";
import IconButton from "@/shared/components/generic/button/IconButton.tsx";
import IconFloppyDisk from "@/shared/components/generic/icons/IconFloppyDisk.tsx";
import { Level, Size } from "@/shared/components/generic/UiEnums.ts";
import useScheduleUserPermissions from "@/pages/human-resources/time-management/hooks/useScheduleUserPermissions.ts";
import useValidateOrShowAlerts from "@/pages/human-resources/time-management/services/hooks/useValidateOrShowAlerts.ts";
import useVisibleEmployeesSchedules from "@/pages/human-resources/time-management/model/schedule-view/useVisibleEmployeesSchedules.ts";
import BasicTooltipWithOffset from "@/pages/human-resources/time-management/components/BasicTooltipWithOffset.tsx";
import { useTranslation } from "react-i18next";
import { filterDraftSchedules } from "@/pages/human-resources/time-management/model/schedule-view/useVisibleDraftSchedules.ts";

export default function ScheduleValidationButton(): ReactNode {
  const { t } = useTranslation(["humanResources"], {
    keyPrefix: "timeManagement",
  });
  const { canValidate, canViewDraft } = useScheduleUserPermissions();
  const validateOrShowAlerts = useValidateOrShowAlerts();
  const visibleSchedules = useVisibleEmployeesSchedules();
  const visibleDrafts = filterDraftSchedules(visibleSchedules);

  return (
    <BasicTooltipWithOffset title={t("scheduleAlerts.validateSchedule")}>
      <div className="schedule-validation-button">
        <IconButton
          icon={IconFloppyDisk}
          level={Level.PRIMARY}
          size={Size.MEDIUM}
          disabled={!canValidate || !canViewDraft || visibleDrafts.length === 0}
          onClick={() => {
            void validateOrShowAlerts(visibleSchedules);
          }}
        />
      </div>
    </BasicTooltipWithOffset>
  );
}
